(() => {
  const initFeaturedCollectionSlider = (el) => {
    if (el.classList.contains('swiper-initialized')) return;
    console.log(el);
    const slidesPerViewMobile = 1.15;
    const slidesPerViewDesktop = 3.2;
    const swiper = new Swiper(el, {
      init: false,
      slidesPerView: parseFloat(slidesPerViewMobile),
      spaceBetween: 8,
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: parseFloat(slidesPerViewDesktop),
        },
      },
      navigation: {
        prevEl: '.swiper-button--prev',
        nextEl: '.swiper-button--next',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<div class="${className} control__dot"></div>`;
        },
      },
    });
    function updatePaginationNumbers() {
      const navigationDots = Array.from(el.querySelectorAll('.control__dot'));
      const activeDot = el.querySelector('.control__dot.swiper-pagination-bullet-active');
      const totalPages = navigationDots.length;
      const activePage = navigationDots.indexOf(activeDot) + 1;
      const currentPageElements = el.querySelectorAll('.swiper--pagination-counter');
      currentPageElements.forEach((element) => {
        const currentPageEl = element.querySelector('.current-page');
        const totalPagesEl = element.querySelector('.total-pages');
        currentPageEl.textContent = activePage;
        totalPagesEl.textContent = totalPages;
      });
      if (totalPages == 1) {
        el.querySelectorAll('.swiper-navigation---wrapper').forEach((element) => {
          element.style.display = 'none';
        });
      }
    }
    swiper.on('slideChange', function () {
      updatePaginationNumbers();
    });
    swiper.on('init', function () {
      updatePaginationNumbers();
    });
    swiper.on('resize', function () {
      updatePaginationNumbers();
    });
    swiper.init();
    el.classList.add('swiper-initialized');
    console.log('Swiper initialized:', swiper);
  };
  document.addEventListener('DOMContentLoaded', () => {
    const matchingElements = document.querySelectorAll('.featured-collection__product-list.swiper');
    matchingElements.forEach((element) => {
      initFeaturedCollectionSlider(element);
    });
  });
})();
